import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import fi from "./locales/fi.json";

export const SUPPORTED_LANGS = ["en", "fi"] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

export const LANG_FLAGS: Record<SupportedLang, string> = {
  en: "🇬🇧",
  fi: "🇫🇮",
};

export function getBrowserLanguage(): SupportedLang {
  if (typeof navigator === "undefined") return "en";
  const langCode = (navigator.language || navigator.languages?.[0] || "").split(
    "-",
  )[0];
  return langCode === "fi" ? "fi" : "en";
}

export const LANG_STORAGE_KEY = "munchi-lang";

function getInitialLanguage(): SupportedLang {
  if (typeof document !== "undefined") {
    // Read from the <html lang="..."> attribute — it's exactly what the server rendered,
    // so the client initializes with the same language and hydration matches.
    const htmlLang = document.documentElement.lang;
    if (SUPPORTED_LANGS.includes(htmlLang as SupportedLang))
      return htmlLang as SupportedLang;
    const match = document.cookie.match(/(?:^|;\s*)munchi-lang=([^;]+)/);
    const lang = match?.[1];
    if (SUPPORTED_LANGS.includes(lang as SupportedLang))
      return lang as SupportedLang;
  }
  return "en";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fi: { translation: fi },
  },
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
